<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="CARROS DO MOTORISTA" :data="[]" :columnsPDF="[]" :headRowsPDF="[]" :fildsTXT="[]" 
            :columnsExcel="[]" :bodyRowsPDF="[]" colSpanPDF="4" :totalPDF="total" :btnHide="true">
                <md-button class="md-button md-site md-just-icon md-round" :to="{ name: 'Dashboard' }">
                    <i class="fas fa-arrow-left"></i>
                    <md-tooltip md-direction="top">Voltar</md-tooltip>
                </md-button>
            </header-table>

            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="CARRO" style="width: 40%">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="PLACA" style="width: 20%">{{ item.placa }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="LIMITE" style="width: 20%">{{ item.limite }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="LIMITE DISPONIVEL" style="width: 20%">{{ item.limite_disponivel }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            permissoes: this.$store.state.usuario.permissao,
            dados: {
                situacao_id: 1
            },
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                busca: ''
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        read(pagi) {
            let loader = this.openLoader('dots');
            this.$http.get(this.$urlAPI + 'motoristas/carros')
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.cpf, item.empresa]).includes(this.toLower(term)))
            }
            return items
        },

    },

};
</script>
